import { ICoordinates, IMeeting, getHeightFromDate, getTopFromDate, zIndexCurrentTimeLine } from '@utils';
import React, { FC, MouseEvent, MouseEventHandler, useEffect, useMemo, useRef, useState } from 'react';
import { Info } from './components/Info';
import { getTitle, onClickMeeting } from './utils';

interface CommonMeetingProps {
  meeting: IMeeting;
  startHour: number;
  setPopupCoordinates: (coordinates: ICoordinates) => void;
  setMoreMeetingInformation: (meeting: IMeeting) => void;
}

export const CommonMeeting: FC<CommonMeetingProps> = ({ meeting, startHour, setPopupCoordinates, setMoreMeetingInformation }) => {
  const ref = useRef<HTMLDivElement>();

  const [zIndex, setZIndex] = useState(meeting.layer + 1);
  const [widthPx, setWidth] = useState(ref?.current?.getBoundingClientRect().width);

  useEffect(() => setWidth(ref?.current?.getBoundingClientRect()?.width), [ref?.current?.getBoundingClientRect()])
  const top = getTopFromDate(meeting.startDate, startHour);
  const height = getHeightFromDate(meeting.startDate, meeting.endDate);

  const width = useMemo(() =>
    100 - (meeting.layer * 10) + '%'
    , [meeting.layer]);

  let timer: NodeJS.Timeout;
  const onMoveMouse: MouseEventHandler<HTMLDivElement> = (e) => {
    if (e.type === 'mouseenter') timer = setTimeout(() => setZIndex(zIndexCurrentTimeLine - 1), 400);
    else {
      setZIndex(meeting.layer + 1);
      clearTimeout(timer);
    }
  };

  const clickMeetingHandler = (e: MouseEvent<HTMLDivElement>) =>
    onClickMeeting(e, true, setPopupCoordinates, meeting, setMoreMeetingInformation);

  const title = useMemo(() =>
    getTitle(meeting, false)
    , [meeting.meetingName, meeting.startDate, meeting.endDate]);

  return (
    <div
      className='meeting fade-in'
      onClick={clickMeetingHandler}
      style={{
        zIndex,
        top,
        height,
        width,
        backgroundColor: meeting.calendarColor,
      }}
      ref={ref}
    >
      <Info
        width={widthPx}
        isDraggingMeeting={false}
        isShowInitiator={false}
        startDate={meeting.startDate}
        endDate={meeting.endDate}
        meeting={meeting}
        title={title}
        onMoveMouse={onMoveMouse}
      />
    </div>
  );
};